<template>
  <RestaurantDeliveriesForm :typeEndPoint="'restaurantDeliveriesShow'" :dataParams="this.$route.params"/>
</template>
<script>
import RestaurantDeliveriesForm from '@/components/modules/restaurant/deliveries/form'
export default {
  name: 'RestaurantDeliveriesEdit',
  components: {
    RestaurantDeliveriesForm
  },
  mounted () {
    console.log(this.$route.params)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/restaurant/deliveries/edit.vue